import MultiFiltering from "./dynamicPageReload/init";
import { registerAppAdjustTracking } from "./appsTracking/AppsTracking";
import { selection } from "./selection/Selection";
import { onReady } from "@otto-ec/global-resources/dom";

onReady.subscribe(() => {
  selection.init();
  MultiFiltering.init();
  registerAppAdjustTracking();
});
